import e from "./isBrowser.js";
export default (function () {
  var o = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : e() && window.location.href;
  return new RegExp(/.+?\:\/\/.+?(\/.+?)(?:#|\?|$)/).exec(o)[1];
});